<template>
  <div class="wrap-start fontSpecial custom-bg-wrap">
    <div class="top-bg">
      <div class="title">
        <p>请选择</p>
        <p>您要测评的人员</p>
      </div>
    </div>
    <div class="center-bg">
      <div class="center-bg-copy">
        <div class="info flex flex-wrap flex-start">
          <div
            class="content-item"
            v-for="(item,index) in userList"
            :key="index"
            @click="toSelect(item)"
          >
            <div class="box-item">
              <p class="name">
                <b>{{item.personName}}</b>
              </p>
              <p class="userinfo">
                <span>{{item.personSex == 0?'女':'男'}}</span>
                <span>{{item.personAge}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-bg">
      <button @click="shade = true" class="addForm-one"></button>
    </div>
    <!-- <div class="start-box">
      <div class="header">
        <p>请选择</p>
        <p>您要测评的人员</p>
      </div>
      <div class="info">
        <div
          class="content-item"
          v-for="(item,index) in userList"
          :key="index"
          @click="toSelect(item)"
        >
          <p class="name">
            <b>{{item.personName}}</b>
          </p>
          <p class="userinfo">
            <span>{{item.personSex == 0?'女':'男'}}</span>
            <span>{{item.personAge}}</span>
          </p>
        </div>
    </div>-->

    <!-- 底部按钮 -->
    <!-- <div class="addForm">
        <button @click="shade = true" class="addForm-one"></button>
      </div>
    </div>-->
    
    <div v-if="shade" class="pop-up">
      <div class="pop-upone">
        <div class="pop-upone-box">
          <p>添加测试人员</p>
          <div class="item">
            <span>姓名：</span>
            <input v-model.trim="addForm.personName" type="text" maxlength="10" />
          </div>
          <div class="item mackitem">
            <span>性别：</span>
            <div class="sex-box" @click="handSele('1')">
              <div class="item-sub">
                <i :class="addForm.personSex==1?'sex-active':'sex-icon'"></i>
                <input type="radio" name="sex" class="radio" />
              </div>
              <b class="sexnan">男</b>
            </div>
            <div class="sex-box" @click="handSele('0')">
              <div class="item-sub">
                <i :class="addForm.personSex==='0'?'sex-active':'sex-icon'"></i>
                <input type="radio" name="sex" class="radio" />
              </div>
              <b>女</b>
            </div>
          </div>
          <div class="item">
            <span>年龄：</span>
            <input v-model.trim="addForm.personAge" type="text" maxlength="3" />
          </div>
        </div>
        
        <div class="foot">
          <div class="foot-left" @click="handleCancel">取消</div>
          <div class="foot-right" @click="addUser">保存</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getApi, postApi } from '../../api/index.js'
export default {
  data() {
    return {
      userList: [],
      shade: false,
      addForm: {
        personAge: '',
        personName: '',
        personSex: ''
      }
    }
  },
  methods: {
    getList() {
      getApi({ url: '/chinese/personList', query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data) {
              this.userList = res.data
              
            }
          }
        })
        .catch(res => {})
    },

    handSele(num) {
      this.addForm.personSex = num
    },
    addUser() {
      this.checkForm()
      postApi({ url: '/chinese/personAdd', query: this.addForm })
        .then(res => {
          if (res && res.resCode == 0) {
            console.log(res.data.personId)
            this.$toast('操作成功')
            this.handleCancel()
            this.getList()
            this.$router.push({
              path:'/medical/select',
              query:res.data
              
            })
          } else {
            this.$toast(res.resMsg || '网络错误，请重试！')
          }
        })
        .catch(res => {
          this.$toast(res.resMsg || '网络错误，请重试！')
        })
    },
    handleCancel() {
      this.shade = false
      this.addForm.personAge = ''
      this.addForm.personName = ''
      this.addForm.personSex = ''
    },
    checkForm() {
      if (!this.addForm.personName) {
        this.$toast('请输入姓名！')
        return
      } else if (!this.addForm.personSex) {
        this.$toast('请选择性别！')
        return
      } else if (!this.addForm.personAge) {
        this.$toast('请输入年龄！')
        return
      } else if (!/^[0-9]*$/g.test(this.addForm.personAge)) {
        this.$toast('请输入正确的年龄！')
      }
    },
    toSelect(item) {
      this.$router.push({
        path: '/medical/select',
        query: { personId: item.personId }
      })
    }
  },
  created() {
    this.getList();
  }
}
</script>

<style lang="less" scoped>
@import '../../common/css/style.less';
.wrap-start {
  height: 100%;
  .info {
    width: 100%;
  }
  .center-bg-copy {
    height: 101%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .start-box {
    padding: 1.6rem 0.42rem 0.46rem 0.38rem;
    box-sizing: border-box;
    width: 100%;
  }
  .addForm-one {
    position: absolute;
    left: 50%;
    bottom: 1.52rem;
    transform: translateX(-50%);
    background-image: url('../../assets/image/start/add.png');
    width: 3.03rem;
    height: 0.88rem;
    background-size: 100%;
    border-radius: 0.44rem;
  }
  .info {
    padding: 0 0.8rem 0.4rem;
    width: 100%;
    box-sizing: border-box;
  }
  .content-item {
    width: 50%;
    margin-bottom: 0.53rem;
    .box-item {
      width: 2.02rem;
      height: 1.92rem;
      border: 0.02rem solid rgb(120, 120, 120);
      margin: 0 auto;
    }
    p {
      text-align: center;
      font-size: 0.36rem;
      // font-weight:bold;
      padding-top: 0.37rem;
    }
    .name {
      margin-bottom: 0.1rem;
    }
    .userinfo span:first-child {
      margin-right: 0.38rem;
    }
  }
  // .info {
  //   width: 100%;
  //   height: 5.23rem;
  // }

  // .addForm button {
  //   width: 3.03rem;
  //   height: 0.88rem;
  //   border-radius: 3rem;
  //   background-size: 100%;
  //   border: 0;
  // }

  .pop-up {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.35);
    box-sizing: border-box;
    padding: 4.16rem 0.97rem 0 0.93rem;
    z-index: 2;
  }
  .pop-upone {
    width: 100%;
    height: 4.82rem;
    background-color: #fff;
    overflow: hidden;
    // padding: 0 0.74rem;
    box-sizing: border-box;
  }
  .pop-upone-box {
    width: 100%;
    padding: 0 0.74rem;
    box-sizing: border-box;
    margin-bottom: 0.35rem;
  }
  .pop-upone p {
    text-align: center;
    // height: 0.34rem;
    font-family: PingFang-SC-Regular;
    font-size: 0.36rem;
    margin-top: 0.46rem;
    margin-bottom: 0.43rem;
  }
  .sex-box {
    display: inline-block;
  }
}
.item {
  // margin-bottom: 0.32rem;
  // height: 0.64rem;
  line-height: 0.64rem;
  input {
    width: 3rem;
    height: 0.64rem;
    border-radius: 0.1rem;
    border: 0;
    background: #eeeeee;
    padding-left: 0.2rem;
    box-sizing: border-box;
  }
  span {
    font-size: 0.3rem;
    color: rgb(153, 153, 153);
  }
  .radio {
    position: absolute;
    width: 0.31rem;
    height: 0.3rem;
    z-index: 10;
    opacity: 0;
  }
  .item-sub {
    display: inline-block;
    top: 0.05rem;
    margin-right: 0.16rem;
    position: relative;
    width: 0.31rem;
    height: 0.3rem;

    i {
      position: absolute;
      display: inline-block;
      width: 0.31rem;
      height: 0.3rem;
      z-index: 5;
      box-sizing: border-box;
      border-radius: 50%;
      // background-image: url(../../assets//image/select.png);
      background-size: 100%;
    }

    .sex-active {
      background-image: url(../../assets/image/start/gou.png);
    }
    .sex-icon {
      border: 0.01rem solid #ccc;
    }
  }
  b {
    font-weight: 400;
    // margin-left: .2rem;
  }

  .sexnan {
    margin-right: 0.67rem;
  }
}
.mackitem {
  margin: 0.1rem 0;
}
.foot {
  width: 100%;
  height: 1rem;
  box-sizing: border-box;
  border-top: 0.01rem solid #eee;
  // border-bottom: .01rem solid #eee;
  line-height: 1rem;
  div {
    display: inline-block;
    width: 50%;
    height: 100%;
    box-sizing: border-box;
    text-align: center;
  }
  .foot-left {
    border-right: 0.01rem solid #eee;
    color: rgb(0, 0, 0);
  }
  .foot-right {
    color: rgb(0, 194, 0);
  }
}
</style>